export default __webpack_public_path__ + "static/media/icon-ob-comms.fb1b463f.svg";